import get from 'lodash/get';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

import { RootState } from 'App';
import { IUser, IUserData, IUserSettings } from 'store/reducers/userReducer/userTypes';
import deepEqualsCreateSelector from 'utils/deepEqualsCreateSelector';

export const userSelector = ({ user }: RootState): IUser => user;

export const isAuthenticatedUserSelector = deepEqualsCreateSelector(
  [userSelector], ({ isAuthenticated }: IUser): boolean => isAuthenticated,
);

export const isLoadingUserSelector = deepEqualsCreateSelector(
  [userSelector], ({ isLoading }: IUser): boolean => isLoading,
);

export const userDataSelector = deepEqualsCreateSelector(
  [userSelector], ({ data }: IUser): IUserData => data,
);

export const userSettingsSelector = deepEqualsCreateSelector(
  [userSelector], ({ settings }: IUser): IUserSettings => settings,
);

export const userSettingsByKeySelector = deepEqualsCreateSelector(
  [({ key, ...state }) => ({ settings: userSettingsSelector(state), key })],
  ({ settings, key }): any => get(settings, key),
);

export const userApprovalStatusSelector = deepEqualsCreateSelector(
  [userSettingsSelector], ({ approvalStatus }) => approvalStatus,
);

export const resolvedConditionsSelector = deepEqualsCreateSelector(
  [(state: RootState, conditions: () => {}[] | []) => ({ state, conditions })],
  ({ state, conditions }) => isArray(conditions) ? map(conditions, (condition) => condition(state)) : [],
);

export const isAdminSelector = deepEqualsCreateSelector(
  [userDataSelector],
  ({ permissions }) => includes(permissions, 'Admin'),
);
